<div class="zoom-toolbar">
  <div matTooltip="Zoom In" matTooltipPosition="left">
    <button matMiniFab id="zoom-in-button" type="button" (click)="zoomIn()" [disabled]="lockZoomIn">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div matTooltip="Zoom Out" matTooltipPosition="left">
    <button matMiniFab id="zoom-out-button" type="button" (click)="zoomOut()" [disabled]="lockZoomOut">
      <mat-icon>remove</mat-icon>
    </button>
  </div>
</div>
